import { login, getUserInfo, logout } from "@/api/loginApi.js"
import Vue from "vue"
import router from "../../router"

const user = {
  state: {
    userInfo: {},
    loadAssetePage: false,
    loadCasePage: false,
  },

  getters: {
    isSuperAdmin: state => {
      return state.userInfo && state.userInfo.roleId === '3'
    }
  },

  mutations: {
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = null
      state.userInfo = userinfo
    },
    LOAD_ASSETS_PAGE: (state, loadAssetePage) => {
      state.loadAssetePage = loadAssetePage
    },
    LOAD_CASE_PAGE: (state, loadCasePage) => {
      state.loadCasePage = loadCasePage
    },
  },

  actions: {
    Login: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        login(data).then(res => {
          Vue.ls.set('token', res.access_token)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    GetUserInfo: ({ commit }) => {
      return new Promise((resolve, reject) => {
        getUserInfo().then((res) => {
          console.log(res);
          commit('SET_USERINFO', JSON.parse(JSON.stringify(res.rows)))
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    LogOut: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        let params = Vue.ls.get('token')
        logout(params).then(res => {
          console.log(res);
          Vue.ls.clear()
          router.replace({ path: '/login' })
        })
        resolve()
      }).catch(() => {
        reject()
      })
    }
  },
}

export default user